export const TEAM_MEMBER_PROFILE_PATH = '/team_member/profile/edit'
export const TEAM_MEMBER_BANK_ACCOUNTS_PATH = '/team_member/bank_accounts'
export const TEAM_MEMBER_OVERVIEW_PATH = '/team_member'
export const TEAM_MEMBER_INVITES_PATH = '/team_member/invites'
export const TEAM_MEMBER_PAYOUTS_SCHEDULE = '/team_member/payouts_balance'
export const TEAM_MEMBER_PAYOUTS_PATH = '/team_member/payouts'
export const TEAM_MEMBER_TRANSFERS_PATH = '/team_member/transfers'
export const TEAM_MEMBER_NOTIFIC_SETTINGS_PATH = '/team_member/notific_settings'
export const TEAM_MEMBER_SUPPORT_PATH = '/team_member/support'
export const TEAM_MEMBER_ONBOARDING_PATH = '/team_member/onboarding_journey'
export const TEAM_MEMBER_ONBOARDING_BUSINESS_PATH = '/team_member/onboarding_journey/business_information'
export const TEAM_MEMBER_ONBOARDING_VERIFICATION_PATH = '/team_member/onboarding_journey/verification'
export const TEAM_MEMBER_ONBOARDING__PAYOUT_PATH = '/team_member/onboarding_journey/payout_details'
export const TEAM_MEMBER_RELOAD_PATH = '/cabinet*'
export const TEAM_MEMBER_NOT_FOUND_PATH = '*'
